<script setup lang="ts">
import { useEventListener } from '@vueuse/core'

/**
 * Blog frame. Same chrome as the marketing layout; the only extra is the
 * newsletter prompt on article pages.
 */
const { isAuthenticated } = useAuthUser()
const { promptNewsletter } = useNewsletterPrompt()
const route = useRoute()

const showError500 = ref(false)

// Injektujeme hodnotu z error-handler pluginu
const nuxtApp = useNuxtApp()
nuxtApp.vueApp.provide('showError500', showError500)

// Handler pro zkušení opětovného načtení stránky
function _handleRetry() {
  showError500.value = false
  window.location.reload()
}

/**
 * Newsletter prompt: only on article pages, and only once the reader has
 * scrolled through ~70 % of the page (i.e. actually read something).
 * Listing, category and pagination pages never prompt.
 */
const isArticlePage = computed(() => {
  // The Czech and German blogs' /cs/blog/… and /de/blog/… the same as the English one's.
  const p = route.path.replace(/^\/(cs|de)(?=\/blog\/)/, '')
  return p.startsWith('/blog/')
    && !p.startsWith('/blog/page')
    && !p.startsWith('/blog/category')
})

const READ_THRESHOLD = 0.7
let prompted = false

function onScroll() {
  if (prompted || !isArticlePage.value || isAuthenticated.value) return
  const doc = document.documentElement
  const scrollable = doc.scrollHeight - window.innerHeight
  if (scrollable <= 0) return
  if (window.scrollY / scrollable >= READ_THRESHOLD) {
    prompted = true
    promptNewsletter()
  }
}

watch(() => route.path, () => { prompted = false })

if (import.meta.client) {
  useEventListener(window, 'scroll', onScroll, { passive: true })
}
</script>

<template>
  <div class="sofax flex min-h-screen flex-col bg-white dark:bg-gray-950">
    <AppNavbar />
    <main class="grow">
      <slot />
    </main>
    <AppFooter />

    <!-- Chat Widget -->
    <LazyIdleCommonChatWidget hydrate-on-idle />

    <ClientOnly>
      <LazyCommonNewsletterDialog v-if="!isAuthenticated" source="blog" />
    </ClientOnly>
  </div>
</template>
